export default __webpack_public_path__ + "static/frame-prime-day-aa24a9c0474f373bafec511cd6dec9a7.mp4";